import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

import { ICONS } from '../../themes'

// Wrapper
// ============================================================
export const CartSupplierStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  position: fixed;
  top: ${VARIABLES.ELEMENT_SIZES.HEADERBAR_HEIGHT + 'px'};
  margin-top: 8px;
  right: 30px;
  width: 350px;
  background-color: white;
  border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
  box-shadow: 0 3px 6px ${VARIABLES.COLORS.SHADOW_2};
  z-index: ${VARIABLES.Z_INDEXS.LV_2};

  /* Child element styles
  ------------------------------- */
  .cart {
    .accordion-head {
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
      color: ${VARIABLES.COLORS.BLUE_1};
      border-bottom: 1px solid;
      border-color: white;

      .cart-header {
        span {
          margin-left: 5px;
        }
      }

      .toggle-icon {
        background-image: url(${ICONS['icon-chevron-down.png']});
        background-size: contain;
        border: 0;
        background-position: center;
        background-repeat: no-repeat;
        height: 6px;

        &:after {
          display: none;
        }
      }
    }

    .accordion-body {
      /* flex-direction: row;
      flex-wrap: wrap; */

      display: inline-block;
      /* height: 0; */

      .scroll-content {
        width: 100%;
        min-height: 50px;
        max-height: 210px;
        overflow-y: auto;
        margin-bottom: 2px;

        /* width */
        ::-webkit-scrollbar {
          width: 5px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
          background: ${VARIABLES.COLORS.GRAY_2};
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: ${VARIABLES.COLORS.BLUE_4};
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
          background: ${VARIABLES.COLORS.BLUE_1};
        }
      }

      .actions {
        border-top: 1px solid ${VARIABLES.COLORS.GRAY_11};
        display: flex;
        justify-content: space-between;
        padding: 14px 45px;
        width: 100%;

        .button {
          width: 125px;
        }
      }
    }

    &.is-open {
      .accordion-head {
        border-color: ${VARIABLES.COLORS.GRAY_11};
      }

      /* .accordion-body {
        height: auto;
      } */
    }
  }

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`

export const CartSupplierItemStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  display: flex;
  align-items: center;
  padding: 9px 11px 0 14px;
  border-bottom: 1px solid ${VARIABLES.COLORS.GRAY_11};

  /* Child element styles
  ------------------------------- */
  .detail {
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    margin-right: 5px;
    max-width: calc(100% - 25px);
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};

    .list {
      width: 100%;
      display: flex;
      margin-bottom: 9px;
      max-width: 100%;

      .label {
        flex: 0 0 47px;
        margin-right: 11px;
        color: #1f2937;
        font-weight: 600;
      }

      .data {
        flex: 1 1 auto;
        color: ${VARIABLES.COLORS.BLUE_1};
        max-width: calc(100% - 67px);
        overflow: hidden;
        white-space: nowrap;
        display: block;
        text-overflow: ellipsis;

        .button {
          text-decoration: underline;
          color: ${VARIABLES.COLORS.BLUE_2};
          font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
          width: auto;
          max-width: 100%;
          overflow: hidden;
          white-space: nowrap;
          display: block;
          text-overflow: ellipsis;
          font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
        }
      }
    }
  }

  .button {
    &.delete {
      flex: 0 0 20px;
      width: 20px;
      height: 20px;
      margin-bottom: 10px;

      .image-control {
        &.delete {
          width: 11px;
        }
      }
    }
  }

  &:last-child {
    border-bottom: 0;
  }

  /* Modifiers
  ------------------------------- */

  /* State
  ------------------------------- */
  &.is-hover-delete {
    background-color: ${VARIABLES.COLORS.RED_OVERLAY_1};
  }

  /* Media queries
  ------------------------------- */
`
